import { Component, AfterViewInit, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NegaraService } from '../services/negara.service';
import { PertanyaanService } from '../services/pertanyaan.service';


declare var intlTelInput: any; 

declare var $: any;

@Component({
  selector: 'app-pertanyaan',
  templateUrl: './pertanyaan.component.html',
  styleUrls: ['./pertanyaan.component.css']
})

export class PertanyaanComponent implements OnInit, AfterViewInit {

  pertanyaanForm: FormGroup;
  data: any[] = [];
  submitted = false;
  formSubmitted = false; // Variabel untuk melacak status pengiriman form

  loading = false; // Spinner state

  @ViewChild('phoneInput', { static: false }) phoneInput!: ElementRef;
   private intlTelInputInstance: any;

   iti: any; // simpan instance intlTelInput

  constructor(private formBuilder: FormBuilder, private negaraService: NegaraService, private pertanyaanService: PertanyaanService) {
    // Membuat form group dengan validasi untuk field yang wajib diisi
    this.pertanyaanForm = this.formBuilder.group({
      nama_pelanggan: ['', Validators.required],
      email_pelanggan: ['', [Validators.required, Validators.email]],
      whatsapp_number: ['', Validators.required],
      negara: ['', Validators.required],
      trip_kategori: ['', Validators.required],
      destinasi: ['', Validators.required],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      inquiry: ['']
    });
  }

  ngOnInit(): void {
    // Mendapatkan data negara dari NegaraService
    this.negaraService.getData().subscribe((response) => {
      this.data = response.data;

       this.initializePhoneInput();
        // this.setPhoneNumber(phoneNumber); 

    });
  }

  ngAfterViewInit(): void {
    // Inisialisasi intlTelInput untuk input WhatsApp
    const input = this.phoneInput.nativeElement;
   this.iti = intlTelInput(input, {
      initialCountry: 'id',
      separateDialCode: true,
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js'
    });

    // Inisialisasi Select2 untuk dropdown negara
    $('#negara').select2({
      theme: 'bootstrap-5', 
      dropdownAutoWidth: true,
      width: '100%',
      placeholder: "Select Country"
    }).on('change', (e: any) => {
      const selectedValue = $(e.target).val();
      this.pertanyaanForm.patchValue({ negara: selectedValue }); // Update form control
    });


    $('#destinasi').select2({
      theme: 'bootstrap-5', 
      dropdownAutoWidth: true,
      width: '100%',
      placeholder: "Select Destination"
    }).on('change', (e: any) => {
      const selectedValue = $(e.target).val();
      this.pertanyaanForm.patchValue({ destinasi: selectedValue }); // Update form control
    });


    $('#kategori').select2({
      theme: 'bootstrap-5', 
      dropdownAutoWidth: true,
      width: '100%',
      placeholder: "Select Trip Category"
    }).on('change', (e: any) => {
      const selectedValue = $(e.target).val();
      this.pertanyaanForm.patchValue({ kategori: selectedValue }); // Update form control
    });

    // Inisialisasi Datepicker untuk tanggal mulai dan tanggal akhir
    $('#start_date').datepicker({
      uiLibrary: 'bootstrap5',
      format: 'dd/mm/yyyy',
      maxDate: function () {
        return $('#end_date').val();
      },
      change: (event: any) => {
        this.onDateChange('start_date', event);
      }
    });

    $('#end_date').datepicker({
      uiLibrary: 'bootstrap5',
      format: 'dd/mm/yyyy',
      minDate: function () {
        return $('#start_date').val();
      },
      change: (event: any) => {
        this.onDateChange('end_date', event);
      }
    });
  }


  onDateChange(controlName: string, event: any): void {
    const selectedDate = event.target.value; // Ambil tanggal yang dipilih
    this.pertanyaanForm.patchValue({ [controlName]: selectedDate }); // Update form control
  }


    private setPhoneNumber(fullPhoneNumber: string) {
    if (!this.intlTelInputInstance) return;
  
   
    this.intlTelInputInstance.setNumber(fullPhoneNumber); // Gunakan intlTelInput untuk mengatur nomor
  
    const countryData = this.intlTelInputInstance.getSelectedCountryData();
    const dialCode = `+${countryData.dialCode}`;
  
    // Ambil hanya nomor tanpa kode negara
    const phoneWithoutDialCode = fullPhoneNumber.replace(dialCode, '').trim();
  
    // Atur nilai input secara manual
    this.pertanyaanForm.patchValue({
      phone: phoneWithoutDialCode
    });
  }

  private initializePhoneInput() {
    if (this.phoneInput && (window as any).intlTelInput) {
        const input = this.phoneInput.nativeElement;

        if (this.intlTelInputInstance) {
            this.intlTelInputInstance.destroy();
        }

        this.intlTelInputInstance = intlTelInput(input, {
            initialCountry: 'id',
            separateDialCode: true,
            loadUtilsOnInit: true // Menghapus utilsScript yang sudah deprecated
        });
    }
  }

  
 onSubmit(): void {
  this.submitted = true;

  // Stop if form is invalid
  if (this.pertanyaanForm.invalid) {
    return;
  }

   this.loading = true; // Start loading

  // Copy form values
  const formData = { ...this.pertanyaanForm.value };

  // Format date to YYYY-MM-DD
  const formatDateToYMD = (date: string) => {
    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };

  formData.start_date = formatDateToYMD(formData.start_date);
  formData.end_date = formatDateToYMD(formData.end_date);

  // Ambil data dari intl-tel-input
  const countryCode = this.iti.getSelectedCountryData().dialCode;
  const fullNumber = this.iti.getNumber(); // Format internasional (+62xxxx)


  formData.whatsapp_number = `+${countryCode}${formData.whatsapp_number}`;

  // Kirim data ke backend
  this.pertanyaanService.simpanPesan(formData).subscribe({
    next: (res) => {
      console.log('Message successfully sent:', res);

      this.formSubmitted = true;
      this.pertanyaanForm.reset();
      this.submitted = false;
       this.loading = false; // Stop loading
    },
    error: (err) => {
      console.error('Failed to send message:', err);
      // alert('An error occurred while sending your message. Please try again.');
       this.loading = false; // Stop loading
    }
  });
}


}

